// extracted by mini-css-extract-plugin
module.exports = {"left-arrow-decal":"LeftArrowDecal_left-arrow-decal__Mj0bS"};